import React, { useState, useRef, useContext } from "react"
import { navigate } from "gatsby"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import { RibbonLink, RibbonContainer } from "./ribbon.styled"
import { renderRichTextDinamo } from "../../../../utils/contentful"
import UserContext from "../../../../context/UserContext"
import { NO_RIBBONLINK_PAGES, RIBBON_MAP } from "../../../../constants"

/**
 **
 * * THIS IS A REGULAR RIBBON, CMS DRIVEN
 */

const Ribbon = (props) => {
  let {
    PROMO_VARIANT = "mayGwp",
    contentfulHeaderRibbon,
    location,
    isMobile = false,
  } = props

  const [isClosed] = useState(false)
  const ribbonEl = useRef(null)
  const userState = useContext(UserContext)

  if (!contentfulHeaderRibbon && !PROMO_VARIANT) {
    return null
  }

  let ribbonHtml = renderRichTextDinamo(contentfulHeaderRibbon?.ribbonText?.raw)
  let isPromo = contentfulHeaderRibbon?.ispromo
  let ribbonHref = contentfulHeaderRibbon?.ribbonLink

  const noLinkRoutes = [ribbonHref]
  /*
   * use this if some page show ribbon but no link
   * const noLinkRoutes = [ribbonHref, ...NO_RIBBONLINK_PAGES]
   */
  if (noLinkRoutes.includes(location?.pathname)) {
    ribbonHref = null
  }
  if (RIBBON_MAP[PROMO_VARIANT]?.copy) {
    ribbonHtml = RIBBON_MAP[PROMO_VARIANT].copy.replace(
      "{name}",
      userState?.customer?.firstname
    )
    isPromo = false
    ribbonHref = RIBBON_MAP[PROMO_VARIANT].href
  }

  const getRibbonAttrs = () => {
    let obj = {
      destination: ribbonHref,
      text: ribbonHtml?.replace(/(<([^>]+)>)/gi, ""),
      type: "ribbon",
      module_location: "ribbon",
    }
    return obj
  }

  const goTo = (e) => {
    segmentEvent("Marketing CTA Clicked", getRibbonAttrs())
    e.preventDefault()
    navigate(ribbonHref)
    return false
  }

  return (
    <RibbonContainer
      style={isClosed ? { display: "none" } : {}}
      className={`${
        isMobile ? "ribbon-mobile" : " ribbon-desktop"
      }  text-center ${location?.pathname?.replaceAll("/", "-")} ${
        isPromo ? "ribbon-promo" : "ribbon-regular"
      }`}
    >
      {ribbonHref ? (
        <RibbonLink
          onClick={goTo}
          ref={ribbonEl}
          href={ribbonHref}
          id={`ribbon`}
          className={`Body-10-Dia-Normal text-center text-nova-base-black`}
          dangerouslySetInnerHTML={{ __html: ribbonHtml }}
        ></RibbonLink>
      ) : (
        <RibbonLink as="section" id="ribbon-no-link">
          <TextElementNova
            element="p"
            text={ribbonHtml}
            className="Body-10-Dia-Normal text-center text-nova-base-black"
            styles={{
              width: "100%",
            }}
          />
        </RibbonLink>
      )}
    </RibbonContainer>
  )
}

export default Ribbon
